<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Business Inteligence</h1>
                </div>

                <div class="card shadow container-fluid special-container">

                    <div class="desktopTabs">
                        <ul class="nav nav-tabs">
                            <li class="active"><a data-toggle="tab" href="#tab1">Dashboard</a></li>
                            <li><a data-toggle="tab" href="#tab2">Data Visualizer</a></li>
                        </ul>
                    </div>

                    <div class="tab-content">
                        <div id="tab1" class="tab-pane fade in active">
                            <app-bi-dashboard></app-bi-dashboard>
                        </div>

                        <div id="tab2" class="tab-pane fade">
                            <app-data-visualizer></app-data-visualizer>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>